// 附件管理
import request from './request'
import request2 from './request2'

// 获取数据
export const getDataAxiosApi = (url, params) => {
  return request({
    url,
    method: 'GET',
    params
  })
}

// 获取nav栏
export const getNavListApi = (params) => {
  return request({
    url: '/igs/front/term/type.jhtml',
    method: 'GET',
    params
  })
}

// 获取搜索结果
export const getSearchListApi = (params) => {
  return request({
    url: '/igs/front/search.jhtml',
    method: 'GET',
    params
  })
}

// 获取搜索热词
export const getHotWordsApi = (params) => {
  return request({
    url: '/igs/front/statistics/find_search_hot_word.jhtml',
    method: 'GET',
    params
  })
}

// 获取搜索智能联想
export const getSuggestWordsApi = (params) => {
  return request({
    url: '/igs/front/suggest/term.jhtml',
    method: 'GET',
    params
  })
}

// 获取相关搜索
export const getRelatedWordsApi = (params) => {
  return request({
    url: '/igs/front/suggest/related.jhtml',
    method: 'GET',
    params
  })
}

// 搜索-匹配专题解读
export const marrySpecialJieduListApi = (params) => {
  return request({
    url: '/ztzl/hotwords.json' + '?v=' + new Date().getTime(),
    method: 'GET',
    params
  })
}

// 搜索-匹配图表
export const marryChartListApi = (params) => {
  return request({
    url: '/zfxxgk/xxgkml/sjfb/excelDatas.json' + '?v=' + new Date().getTime(),
    method: 'GET',
    params
  })
}

// 获取省市县乡位置名称
export const getRegionListApi = (data) => {
  return request({
    url: '/web/bszn/region/findRegionList.jspc',
    method: 'POST',
    data
  })
}

// 获取服务数据（raw方式post）
export const getServiceListApi = (data) => {
  return request2({
    url: '/zwfwsearch/854ed503f5fa4e6dba06e7158d4a2442',
    method: 'POST',
    data: data
  })
}